export default __webpack_public_path__ + "static/media/b5.953f99a7.png";